export enum RequestMethods {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
}

export enum AppRoutes {
  HOME = "/",
  ACCOUNTS = "/accounts",
  ACCOUNT = "/account",
  ACCOUNTS_LIST = "/accounts/list",
  CAMPAINGS = "/campaigns",
  CAMPAIGNS_REQUIREMENTS = "/campaigns/requirements",
  LOGIN = "/login",
  REGISTRATION = "/sign-up",
  FORGOT_PASSWORD = "/forgot-password",
  VERIFY_CODE = "/verify-code",
  RESET_PASSWORD = "/reset-password",
  PROFILE = "/profile",
  CREATE_CAMPAIGN = "/create-campaign",
  REVIEWS = "/reviews",
  AUTH = "/oauth/callback",
  ACCOUNT_PLAN = "/account-plan",
  PLAYBOOK = "/playbook",
}

export enum UploadFlow {
  FILE = "uploaded_from_file",
  HUBSPOT = "hubspot_disconnected",
  SALESFORCE = "salesforce_disconnected",
}

export enum KeyRoles {
  decision_maker = "decision_maker",
  initiator = "initiator",
  influencer = "influencer",
  technical_buyer = "technical_buyer",
  champion = "champion",
  user = "user",
  approver = "approver",
  legal_compliance_advisor = "legal_compliance_advisor",
  blocker = "blocker",
  buyer = "buyer",
  not_involved = "not_involved",
}

export enum UserRoles {
  admin = "admin",
}

export enum RateIndicator {
  up = "up",
  down = "down",
}

export enum Groups {
  cluster = "cluster",
  committee = "committee",
}

export enum RoleStatus {
  active = "active",
  disabled = "disabled",
  excluded = "excluded_for_size",
}

export enum JobTitlesType {
  ignored = "ignored",
  approved = "approved",
  suggested = "suggested",
}

export enum AccountPlanStatus {
  ready = "ready",
  in_progress = "in_progress",
  completed = "completed",
  failed = "failed",
  updating = "updating",
  needs_update = "needs_update",
  account_plan_generating = "account_plan_generating",
}

export enum NotificationTypes {
  scraping = "scraping",
  analysis = "analysis",
  account_plan_generation = "account_plan_generation",
  sdr_playbook_generation = "sdr_playbook_generation",
}

export enum ActivitiesStatus {
  in_progress = "in_progress",
  completed = "completed",
  failed = "failed",
  queued = "queued",
  updating = "updating",
}

export enum ShareCampaignRoles {
  editor = "editor",
  owner = "owner",
  admin = "admin",
}

export enum Integration {
  hubspot = "hubspot",
  salesforce = "salesforce",
  lead_tools = "lead_tools",
}

export enum ManageSectionsModals {
  account_plan = "Account Plan",
  playbook = "SDR Playbook",
  none = "",
}

export enum ExportAccountsOptions {
  all = "All Accounts",
  selected = "Selected Accounts",
}

export enum ExportDataModals {
  account_plan = "Account Plans (PDF)",
  account_plan_links = "Account Plan Links (CSV)",
  csv = "Analysis Report (CSV)",
  playbook = "Playbook Links (CSV)",
  none = "",
}

export enum ManageFields {
  sdr_playbook_fields = "sdr_playbook_fields",
  account_plan_fields = "account_plan_fields",
}

export enum GenerateReportsModals {
  account_plan = "Account Plans",
  playbook = "SDR Playbooks",
  none = "",
}

export enum PlaybookFilter {
  all = "all",
  without_playbooks = "without_playbooks",
  with_playbooks = "with_playbooks",
}

export enum ColumnType {
  grid = "grid",
  row = "row",
}

export enum BuyerJourneyOption {
  target = "Target",
  awareness = "Awareness",
  consideration = "Consideration",
  decision = "Decision",
  purchase = "Purchase",
}

export enum UploadMethodsOption {
  crm = "Sync CRM",
  desktop = "Upload File",
  manually = "Manually",
  cid = "Sync by CID",
}

export enum topicTitlesMapper {
  read_first = "Understanding the Prospect Type",
  do_dont = "Do’s and Don'ts for Engaging Intent-Based Prospects",
  lead_details = "Prospect Details",
  outreach_research = "Part 1: Immediate Prep + Fast Track Outreach (Day 0-3)",
  outbound_sequence = "Part 2: 7-Day Outbound Sequence (Day 3–10)",
  first_call = "SDR First Call Script",
  amnesia_best_practices = "Prospect Amnesia Best Practices",
  crm_notes = "CRM Notes to Capture",
}
